import { apiClient } from "@/services/api"


const state = () => ({
    portais: null,
    selectedPortal: null,
    selectedEditoria: localStorage.getItem("@socialcam/cod_editoria_portal") ?? null
})

const getters = {
    getterPortais: state => {
        return state.portais
    },
    getterSelectedPortal: state => {
        return state.selectedPortal
    },
    getterSelectedEditoriaPortal: state => {
        return state.selectedEditoria
    },
    getPortalDisplayName: state => (codPortal) => {
        if (!codPortal || !state.portais) return codPortal;
        const portal = state.portais.find(p => p.cod_portal === codPortal);
        return portal ? portal.dsc_portal : codPortal;
    }
}

const actions = {
    async getPortais({ commit }) {
        const portalsToNotShow = [];
        await apiClient.get(`portais/listarPortais`)
        .then((response) => {
            commit('setPortais', response.data.portais.filter(portal => !portalsToNotShow.includes(portal.cod_portal)))
        }).catch(error => {
            console.error(error.message)
        })
    },

    setSelectedPortal({ commit }, value) {
        try {
            commit("setSelectedPortal", value)
        } catch(error) {
            return error
        }
    },
    setSelectedEditoriaPortal({ commit }, value) {
        try {
            commit("setSelectedEditoriaPortal", value)
        }catch(error) {
            return error;
        }
    }
}

const mutations = {
    setPortais(state, payload) {
        state.portais = payload
    },
    setSelectedPortal(state, value) {
        state.selectedPortal = value
    },
    setSelectedEditoriaPortal(state, value) {
        state.selectedEditoria = value
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}